var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSauna(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2992_1325",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 47,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.75 7.5H6.25V54H52.75V7.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2992_1325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8707 22.8649L40.9719 23.3105C39.6157 23.6205 38.5501 24.6862 38.2401 26.0424L37.7944 27.9411C37.7557 28.1349 37.4651 28.1349 37.4069 27.9411L36.9613 26.0424C36.6513 24.6862 35.5857 23.6205 34.2294 23.3105L32.3307 22.8649C32.1369 22.8262 32.1369 22.5355 32.3307 22.4774L34.2294 22.0318C35.5857 21.7218 36.6513 20.6562 36.9613 19.2999L37.4069 17.4012C37.4457 17.2074 37.7363 17.2074 37.7944 17.4012L38.2401 19.2999C38.5501 20.6562 39.6157 21.7218 40.9719 22.0318L42.8707 22.4774C43.0644 22.5162 43.0644 22.8068 42.8707 22.8649Z",
    stroke: "#BC8639",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8074 47.2195L29.3842 44.6426",
    stroke: "#BC8639",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6081 33.6758C47.8287 34.412 48.6231 35.6908 48.7587 37.1052C48.7587 40.2827 43.7212 42.9758 36.5912 44.0995",
    stroke: "#BC8639",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1604 33.6758C10.9398 34.412 10.1454 35.6908 10.0098 37.1052C10.0098 41.2708 18.6898 44.642 29.3848 44.642",
    stroke: "#BC8639",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4966 33.3075C34.7141 35.3806 32.0985 36.5625 29.3666 36.5625C26.6348 36.5625 24.0386 35.3806 22.2367 33.3075C19.0979 29.7037 19.1367 24.3369 22.2754 20.7331L26.8673 15.4244C27.5066 14.6881 28.4173 14.2812 29.386 14.2812C30.3548 14.2812 31.2848 14.7075 31.9048 15.4244",
    stroke: "#BC8639",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSauna);
export default __webpack_public_path__ + "static/media/sauna.48eaefe487ab454aa35dfc506e8da00d.svg";
export { ForwardRef as ReactComponent };